<script>
import CartItemDomain from "$vueCommon/components/Cart/CartItemDomain.vue";
import CartItemFee from "$vueCommon/components/Cart/CartItemFee.vue";

export default {
    components: {
        CartItemDomain, CartItemFee
    },
    props: {
        items: Array,
        identities: Array,
        dnsProfiles: Array,
        saving: Object,
        source: String
    },
    mounted() {},
    methods: {
        isSaving(domain) {
            return this.saving[domain.rowId];
        },
        filter(associate) {
            return this.items.filter(item => item.associate === associate);
        }
    },
    computed: {
        domainItems() {
            return this.items.filter(
                item => item.associate === 'Domain' ||
                    item.associate === 'DomainRenew' ||
                    item.associate === 'DomainTrade' ||
                    item.associate === 'IdProtect');
        },
        feeItems() {
            return this.items.filter(item => item.associate === 'PaymentCommission');
        }
    }
}
</script>
<template>
    <h2 class="h4">{{ $translate('checkout.domains') }}</h2>
    <template v-for="item in domainItems">
        <CartItemDomain
            :domain="item"
            :source="source"
            :identities="identities"
            :dnsProfiles="dnsProfiles"
            :isSaving="isSaving(item)"
        />
    </template>
</template>
